import React from "react";
import { PendingOrder, ConfirmDialogState, BulkEditFields, BulkCreateFields } from "../types";
import { RiskByCompanyId } from "../riskViolations";
import { TableRow } from "./TableRow";
import styles from "../OrderRecommendationList.module.css";

interface OrderTableProps {
  groupedByCompany: PendingOrder[][];
  isBulkEditing: boolean;
  bulkEditState: Record<number, BulkEditFields>;
  bulkEditSnapshot: Record<number, BulkEditFields>;
  bulkCreateState: Record<string, BulkCreateFields>;
  bulkCreateSnapshot: Record<string, BulkCreateFields>;
  handleBulkEditChange: (id: number, field: keyof BulkEditFields, value: BulkEditFields[keyof BulkEditFields]) => void;
  handleBulkCreateChange: (companyId: number, strategyGroup: "LHF" | "CORE", field: keyof BulkCreateFields, value: BulkCreateFields[keyof BulkCreateFields]) => void;
  setConfirmDialog: React.Dispatch<React.SetStateAction<ConfirmDialogState>>;
  errorEditIds: number[];
  errorCreateKeys: string[];
  lastOrderFilter?: string;
  riskByCompanyId: RiskByCompanyId;
  /** Patches the row after a CIO note is saved, so the icon updates without a refetch. */
  applyCioNote: (companyId: number, cioNote: string | null) => void;
}

export const OrderTable: React.FC<OrderTableProps> = ({
  groupedByCompany,
  isBulkEditing,
  bulkEditState,
  bulkEditSnapshot,
  bulkCreateState,
  bulkCreateSnapshot,
  handleBulkEditChange,
  handleBulkCreateChange,
  setConfirmDialog,
  errorEditIds,
  errorCreateKeys,
  lastOrderFilter,
  riskByCompanyId,
  applyCioNote,
}) => (
  <>
    {groupedByCompany.map((companyOrders, companyIdx) => {
      const rowCount = companyOrders.length;
      const first = companyOrders[0];
      return (
        <tbody key={`company-${first.company || companyIdx}`} className={styles["company-block"]}>
          {companyOrders.map((order, subIdx) => {
            const sg = (order.strategy_group ?? "CORE") as "LHF" | "CORE";
            if (order.is_placeholder) {
              return (
                <TableRow key={`indicator-${order.id}`}
                  variant="indicator" order={order} isFirst={subIdx === 0}
                  rowSpan={rowCount} first={first} isBulkEditing={isBulkEditing}
                  strategyGroup={sg} bulkCreateState={bulkCreateState}
                  bulkCreateSnapshot={bulkCreateSnapshot}
                  handleBulkCreateChange={handleBulkCreateChange}
                  isErrorRow={errorCreateKeys.includes(`${order.company}_${sg}`)}
                  lastOrderFilter={lastOrderFilter}
                  riskByCompanyId={riskByCompanyId}
                  applyCioNote={applyCioNote} />
              );
            }
            return (
              <TableRow key={order.id}
                variant="pending" order={order} isFirst={subIdx === 0}
                rowSpan={rowCount} first={first} isBulkEditing={isBulkEditing}
                bulkEditState={bulkEditState} bulkEditSnapshot={bulkEditSnapshot}
                handleBulkEditChange={handleBulkEditChange}
                setConfirmDialog={setConfirmDialog}
                isErrorRow={errorEditIds.includes(order.id)}
                lastOrderFilter={lastOrderFilter}
                riskByCompanyId={riskByCompanyId}
                applyCioNote={applyCioNote} />
            );
          })}
        </tbody>
      );
    })}
  </>
);
